import { CText } from "@carrefour/design-system-components-react";
import Box from "../Box";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { COLORS } from "../../utils/colors";

const Text = styled(CText)<{ color?: string }>`
  color: ${(props) => props.color};
  font-family: system-ui;
`;

const InfoBarSlot = () => {
  
  const {t} = useTranslation();

  return (
    <Box
      display={"flex"}
      pt={2}
      width={["100%", "40%"]}
      justifyContent={"space-between"}
      alignSelf={"center"}
      data-testid={"info-bar-slot-container"}
    >
      <Box
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
        width={"70px"}
      >
        <svg
          role="img"
          width="17"
          height="16"
          viewBox="0 0 17 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="0.5" width="16" height="16" rx="2" fill={COLORS.bg_red} />
          <rect x="3.5" y="3" width="10" height="10" rx="1" fill="#AA0D11" />
        </svg>

        <Text color={"black"}>{t('ecommerce.sature_ferme')}</Text>
      </Box>
      {/* green */}
      <Box display={"flex"} flexDirection={"column"} alignItems={"center"}>
        <svg
          role="img"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="16" height="16" rx="2" fill="#F9FFF2" />
          <rect x="3" y="3" width="10" height="10" rx="1" fill="#33691E" />
        </svg>

        <Text color={"black"}>{t('ecommerce.vide')}</Text>
      </Box>

      {/* yellow */}
      <Box
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
        width={"70px"}
        pt={0}
      >
        <svg
          role="img"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="16" height="16" rx="2" fill="#F5FAFF" />
          <rect x="3" y="3" width="10" height="10" rx="1" fill="#173EB4" />
        </svg>

        <Text color={"black"}>{t('ecommerce.partiellement_rempli')}</Text>
      </Box>
      {/* close */}
      <Box
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
        pt={0}
      >
        <svg
          role="img"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="16" height="16" rx="2" fill="#F5FAFF" />
          <g clip-path="url(#clip0_1466_8374)">
            <rect x="3" y="3" width="10" height="10" rx="1" fill="#E5E5E5" />
            <line
              x1="2.52561"
              y1="14.3062"
              x2="6.34286"
              y2="2.84192"
              stroke="#262626"
            />
            <line
              x1="6.34299"
              y1="14.3062"
              x2="10.1602"
              y2="2.84192"
              stroke="#262626"
            />
            <line
              x1="10.1604"
              y1="14.3062"
              x2="13.9776"
              y2="2.84192"
              stroke="#262626"
            />
          </g>
          <defs>
            <clipPath id="clip0_1466_8374">
              <rect x="3" y="3" width="10" height="10" rx="1" fill="white" />
            </clipPath>
          </defs>
        </svg>

        <Text color={"black"}>{t('ecommerce.ferme')}</Text>
      </Box>
    </Box>
  );
};

export default InfoBarSlot;
